import { DownloadItemType } from "../../types";
import { getRequestWrapper } from "../../utilities";

type getEnvironmentsByAppIdParams = {
  store_id: string | number;
};

// Response ----------

export type getEnvironmentsByAppIdResponse = { body: DownloadItemType[] };

// Request ----------

export function getEnvironmentsByAppId(
  id: string,
  params?: getEnvironmentsByAppIdParams
): Promise<getEnvironmentsByAppIdResponse> {
  return getRequestWrapper<
    getEnvironmentsByAppIdParams,
    getEnvironmentsByAppIdResponse
  >({
    url: `${ENV_SETTINGS.API_URL}/apps/${id}/environments`,
    params,
  });
}
